<template>
	<v-container :class="{'px-0': $vuetify.breakpoint.smAndDown}">
		<v-row class="my-4 mx-auto" style="max-width: 500px">

			<v-col cols="12">
				<h1 class="text-center accent--text mb-0">Регистрация</h1>
			</v-col>

			<v-col cols="12">
        <v-card outlined class="base-card pa-8">
          <div v-if="registrationStep === 1">
            <v-row class="mx-0 mt-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-text-field
                  class="pa-0 pt-2 ma-0"
                  v-model="form.email"
                  label="Электронная почта"
                  :error-messages="emailErrors"
                  @input="$v.form.email.$touch()"
                  @blur="$v.form.email.$touch()"
                />
              </v-col>

              <v-col cols="12" class="ma-0 px-0 d-flex" >
                <v-checkbox
                  v-model="form.checkbox"
                  class="mt-0 pt-0 mr-2 primary--text"
                />

                <div
                  class="checkbox-description"
                  @click="form.checkbox = !form.checkbox"
                >
                  {{ checkboxDescription }}
                </div>
              </v-col>
            </v-row>

            <v-row class="mx-0 mb-0">
              <v-col cols="4" class="pa-0 mt-4">
                <v-btn
                  depressed
                  color="primary"
                  class="mr-2"
                  :loading="loading"
                  :disabled="$v.form.$invalid"
                  @click="startRegistration"
                >
                  Отправить
                </v-btn>
              </v-col>

              <v-col cols="8" class="pa-0 mt-5 d-flex justify-end">
                <v-btn text small color="primary" class="pr-2" to="/login">
                  Страница входа
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <div v-if="registrationStep === 2">
            <v-row class="mx-0 my-0">
              <v-col cols="12" class="pa-0 ma-0">
                <v-alert type="info" outlined class="body-2 mb-0">
                  На Ваш почтовый ящик отправлено письмо, содержащее ссылку для подтверждения регистрации
                </v-alert>
              </v-col>
            </v-row>
          </div>

          <div v-if="registrationStep === 3">
            <PasswordCreate
              :confirmParams="confirmParams"
              type="registration"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authApi } from '@/api'
import { required, sameAs, maxLength, email } from 'vuelidate/lib/validators'
import PasswordCreate from '@/components/auth/PasswordCreate'

export default {
  name: "Registration",

  components: {
    PasswordCreate
  },

  metaInfo: {
    title: 'Регистрация'
  },

  created() {
    this.setBaseRegistrationStep()
  },

	data: () => ({
    registrationStep: null, // 1, 2, 3
    loading: false,
    form: {
      email: null,
      checkbox: null
    },
    confirmParams: {
      login: null,
      code: null
    },
    checkboxDescription: `Нажимая кнопку «Отправить», я подтверждаю свою дееспособность,
		даю согласие на обработку ФГБОУ ВО СЗГМУ им. И.И. Мечникова моих персональных данных,
		а именно на их сбор, систематизацию, н  акопление, хранение, уточнение (обновление, изменение),
		использование, обезличивание, блокирование, передачу, уничтожение.`
  }),

  validations() {
    return {
      form: {
        email: {
          required,
          email,
          maxLength: maxLength(50)
        },

        checkbox: {
          sameAs: sameAs(() => true)
        }
      }
    }
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.email && errors.push('E-mail невалидный')
      return errors
    }
  },

  methods: {
    setBaseRegistrationStep() {
      if (this.$route.name === 'registration') {
        this.registrationStep = 1
      } else if (this.$route.name === 'registrationConfirm') {
        this.registrationStep = 3
        this.confirmParams.login = this.$route.params.login
        this.confirmParams.code = this.$route.params.code
      }
    },

    async startRegistration() {
      try {
        this.loading = true

        await authApi.startRegistration(this.form.email)
        this.registrationStep = 2
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка регистрации')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.checkbox-description {
  color: var(--accent-color);
  line-height: 1.25;
  cursor: pointer;
}
</style>